import { Component, OnChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from "../../model/guru-entity";
import {FormsModule} from "@angular/forms";
import {MatSlideToggle} from "@angular/material/slide-toggle";

import {StringUtils} from "../../utils/string-utils";
import {GuruAllowable} from "../../model/guru-allowable";

@Component({
    selector: 'app-configuration-input',
    imports: [FormsModule, MatSlideToggle],
    templateUrl: './configuration-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './configuration-input.component.css'
})
export class ConfigurationInputComponent implements OnChanges {

  readonly selectionInput = input.required<GuruEntity>({ alias: 'selection' });
  readonly invalidSelections = input.required<string[]>();
  readonly isBusy = input.required<boolean>();
  readonly selectionValueChanged = output<GuruEntity>();
  readonly booleanValueChanged = output<GuruEntity>();

  constructor() {
  }

  ngOnChanges(): void {
  }

  isInvalidSelection(): boolean {
    return (this.invalidSelections()?.length || 0) > 0
      && this.invalidSelections().indexOf(this.selectionInput().Name) >= 0;
  }

  isListSelection(): boolean {
    return StringUtils.equalsIgnoreCase('LIST', this.selectionInput().EntityType);
  }

  isBooleanSelection(): boolean {
    return StringUtils.equalsIgnoreCase('BOOLEAN', this.selectionInput().EntityType);
  }

  selectionChanged(): void {
    this.selectionValueChanged.emit(this.selectionInput());
  }

  booleanChanged(): void {
    this.booleanValueChanged.emit(this.selectionInput());
  }

  getFalseAllowableText(): string {
    if (this.hasLongAllowableText()) {
      return 'No';
    }
    if ((this.selectionInput()?.Allowables?.length || 0) === 2) {
      const filtered: GuruAllowable[] = this.selectionInput().Allowables.filter((allowable: GuruAllowable) => StringUtils.equalsIgnoreCase('false', allowable.Value));
      if (filtered.length === 1) {
        return filtered[0].Description;
      }
    }
    return undefined!;
  }

  private hasLongAllowableText(): boolean {
    if ((this.selectionInput()?.Allowables?.length || 0) === 0) {
      return false;
    }
    const filtered: GuruAllowable[] = this.selectionInput().Allowables.filter((allowable: GuruAllowable) => (allowable.Description?.length || 0) >= 20);
    return filtered.length > 0;
  }

  getTrueAllowableText(): string {
    if (this.hasLongAllowableText()) {
      return 'Yes';
    }
    if ((this.selectionInput()?.Allowables?.length || 0) === 2) {
      const filtered: GuruAllowable[] = this.selectionInput().Allowables.filter((allowable: GuruAllowable) => StringUtils.equalsIgnoreCase('true', allowable.Value));
      if (filtered.length === 1) {
        return filtered[0].Description;
      }
    }
    return undefined!;
  }

  isSelected(): boolean {
    return StringUtils.equalsIgnoreCase('true', this.selectionInput().Value);
  }

}
